import React from "react";
import * as Datas from "@data";
import styles from "./style.module.scss";
import {Modal} from "@adminComponents";
import {Images, Svgs} from "@assets";
import {useKakaoMap} from "@hook";
import {useEffect, useState} from "react";

const MAP_ID = "info_map";

export function DetailModal({
  detail,
  close,
}: {
  detail?: Datas.IMemberResponse;
  close: () => void;
}) {
  const {map, drawMap, setCenterByAddress} = useKakaoMap({mapId: MAP_ID});
  const [isHideMap, setIsHideMap] = useState(true);
  const [latLng, setLatLng] = useState<[number, number]>();

  const photo = detail?.photo?.[0].url;
  const fileList = (detail?.files || [])
    .map(item => item?.url)
    .filter(item => !!item);

  async function setMapCenter() {
    if (detail?.company_address) {
      try {
        const coords = await setCenterByAddress(detail?.company_address);
        if (coords) {
          setLatLng([coords.lat, coords.lng]);
          setIsHideMap(false);
        } else {
          setIsHideMap(true);
        }
      } catch (error) {
        setIsHideMap(true);
      }
    } else {
      setIsHideMap(true);
    }
  }

  useEffect(() => {
    if (!detail?.company_address) {
      return;
    }

    setMapCenter();
  }, [detail?.company_address, map]);

  useEffect(() => {
    if (detail) {
      drawMap();
    } else {
      setIsHideMap(true);
    }
  }, [detail]);

  if (!detail) {
    return <></>;
  }

  return (
    <Modal visible={!!detail} className={styles.modalContainer}>
      <div className={styles.modal}>
        <div className={styles.close} onClick={close}>
          <Svgs.Close width={18} />
        </div>
        <div className={styles.modalTitle}>프로필</div>
        <div className={styles.infoSection}>
          <div className={styles.imgContainer}>
            <img src={photo || Images.noImage} />
          </div>
          <div className={styles.textContainer}>
            <div className={styles.title}>
              {detail.sequnce}기 {detail.position} <b>{detail.name}</b>
              {!!detail.coach && <div>{detail.coach}</div>}
              {!!detail.company && <div>{detail.company}</div>}
            </div>
            <div className={styles.info}>
              {!!detail.company_work && (
                <div className={styles.row}>
                  <div>
                    <Svgs.Arrow />
                  </div>
                  {detail.company_work}
                </div>
              )}
              {!!detail.company_address && (
                <div className={styles.row}>
                  <div>
                    <Svgs.Location />
                  </div>
                  {detail.company_address}
                </div>
              )}
              {!!detail.tel && (
                <div className={styles.row}>
                  <div>
                    <Svgs.Phone />
                  </div>
                  {detail.tel}
                </div>
              )}
            </div>
            <button
              disabled={!detail.tel}
              className={styles.btn}
              onClick={() => window.open(`tel:${detail.tel}`)}>
              전화걸기
            </button>
          </div>
        </div>
        {fileList.length > 0 && (
          <div className={styles.filesContainer}>
            {fileList.map((item, index) => (
              <img key={index} src={item} alt="file" />
            ))}
          </div>
        )}
        <div
          className={[
            styles.mapContainer,
            isHideMap ? styles.hide : undefined,
          ].join(" ")}>
          <div id={MAP_ID} className={styles.map} />
        </div>
      </div>
    </Modal>
  );
}
